import React from 'react';
import { NavLink, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { routes } from '../../../routes';
import userActions from '../../../redux/user';
import magic from '../../../util/magic';

import Card from '../../../components/Card';
import AccountSettings from './AccountSettings';
import ContactInfo from './ContactInfo';
import ProfessionalInfo from './ProfessionalInfo';
import AFCPESettings from './AFCPESettings';
import CanvasSettings from './CanvasSettings';
import SocialDetails from './SocialDetails';

const mapStore = (store) => ({
  user: store.user,
  workAreas: store.workAreas,
  areasOfExpertise: store.areasOfExpertise,
});

const mapDispatch = {
  ...userActions,
};

const propTypes = {
  user: PropTypes.object,
};

const EditAccount = (props) => (
  <Card>
    <Card.Header>Edit My Account</Card.Header>
    <Card.Body>
      <div className="row">
        <div className="nav flex-column nav-pills col-sm-3" role="tablist" aria-orientation="vertical">
          <NavLink exact to={routes.editProfile.root} className="nav-link">
            Contact Info
          </NavLink>
          <NavLink to={routes.editProfile.accountSettings} className="nav-link">
            Account Settings
          </NavLink>
          <NavLink to={routes.editProfile.professionalInfo} className="nav-link">
            Professional Info
          </NavLink>
          <NavLink to={routes.editProfile.afcpeSettings} className="nav-link">
            Sage Financial Solutions Settings
          </NavLink>
          {props.user.role === magic.adminRole && (
            <NavLink to={routes.editProfile.canvasSettings} className="nav-link">
              Canvas Settings
            </NavLink>
          )}
          <NavLink to={routes.editProfile.socialDetails} className="nav-link">
            Social Details
          </NavLink>
        </div>
        <div className="tab-content col-sm-9" id="tabContent">
          <Route exact path={routes.editProfile.root} render={() => <ContactInfo {...props} />} />
          <Route exact path={routes.editProfile.accountSettings} render={() => <AccountSettings {...props} />} />
          <Route path={routes.editProfile.professionalInfo} render={() => <ProfessionalInfo {...props} />} />
          <Route path={routes.editProfile.afcpeSettings} render={() => <AFCPESettings {...props} />} />
          <Route path={routes.editProfile.canvasSettings} render={() => <CanvasSettings {...props} />} />
          <Route path={routes.editProfile.socialDetails} render={() => <SocialDetails {...props} />} />
        </div>
      </div>
    </Card.Body>
  </Card>
);

EditAccount.propTypes = propTypes;

export default connect(mapStore, mapDispatch)(EditAccount);
